"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNumericProperty = void 0;
var getDataType_1 = require("./getDataType");
var isNumericProperty = function (property, assetTypeDefinitions) {
    if (property === '')
        return false;
    var propertyDataType = (0, getDataType_1.getDataType)(property, assetTypeDefinitions);
    if (propertyDataType === undefined)
        return false;
    if (propertyDataType === 'int' || propertyDataType === 'float') {
        return true;
    }
    else {
        return false;
    }
};
exports.isNumericProperty = isNumericProperty;
//# sourceMappingURL=isNumericProperty.js.map